import React from 'react'
import Icon from '../Icon'
import componentStyles from './SidePanelFramework.module.scss'
import classNames from 'classnames'
import { SidePanelFrameworkProps } from './types'
import { iconName } from '../Icon/types'

class SidePanelFramework extends React.PureComponent<SidePanelFrameworkProps> {

  render () {

    const {
      title = '',
      content,
      icon = iconName.info,
      isCloseable = false,
      onClose = () => {},
      scrollable = false,
      contentPadding = true,
      dataBdd = 'side-panel-framework',
      clearBottom = true,
      children = <div />
    } = this.props

    return <div className={componentStyles['side-panel-framework']}
                data-bdd={dataBdd} >
      <div className={componentStyles[`side-panel-framework__header`]}
           data-bdd={`side-panel-header`}>
        <Icon name={icon}  />
        <span
          className={componentStyles[`side-panel-framework__title`]}
          data-bdd={`side-panel-header-text`} >{title}
        </span>
        {
          isCloseable &&
          <button id={`side-panel-framework__close-button`}
            onClick={onClose}
            className={componentStyles['side-panel-framework--clear-button']}>
            <Icon name={iconName.close} />
          </button>
        }
      </div>

      <div className={ classNames({[componentStyles[`side-panel-framework__clear-bottom-wrapper`]]: clearBottom})}>
        <div className={ classNames(
          componentStyles[`side-panel-framework__content`],
          {
            [componentStyles[`side-panel-framework__content-scrollable`]]: scrollable,
            [componentStyles[`side-panel-framework__content-padding`]]: contentPadding,
            [componentStyles[`side-panel-framework__clear-bottom-content`]]: clearBottom
          }) }>
            { content ?? children }
          </div>
      </div>

    </div>

  }

}

export default SidePanelFramework
